module.exports = __webpack_public_path__ + "img/Fuss_Outline.aed480a.svg";